import { useEffect, useState } from 'react';
import { ListResource } from '../../components';
import { useColumns } from './columns';
import { ExtraFilters } from './ExtraFilters';
import { useFormatter } from '../../utils/formatter';
import { headers } from './headers';
import { useListWithAddressFilters } from '../owners/utils/useListWithAddressFilters';

/**
 * Renders a list of pensioners with filter options.
 * @component
 *
 * @returns {JSX.Element} The rendered ListPensioners component.
 */
export const ListPensioners = () => {
  const [forceRefresh, setForceRefresh] = useState(false);
  const { formattedData } = useFormatter();
  const { columns } = useColumns(setForceRefresh);
  const {
    cityOptions,
    departmentOptions,
    setCityFilter,
    setDepartmentFilter,
    isFieldsLoading,
    extraQuery
  } = useListWithAddressFilters('pensioners');

  useEffect(() => {
    if (forceRefresh) {
      setForceRefresh(false);
    }
  }, [forceRefresh]);

  return (
    <ListResource
      resourceName="pensioners"
      columns={columns}
      headers={headers}
      resourceModelName="Pensioner"
      withArchiveButton
      extraQuery={extraQuery}
      customActionColumn
      forceRefresh={forceRefresh}
      formatter={formattedData}
      withoutImportButton
      scroll={{ x: 1100 }}
      extraFilters={
        <ExtraFilters
          isFieldsLoading={isFieldsLoading}
          cityOptions={cityOptions}
          departmentOptions={departmentOptions}
          setCityFilter={setCityFilter}
          setDepartmentFilter={setDepartmentFilter}
          translationKey="pensioners"
        />
      }
      backIcon={false}
    />
  );
};
